<section class="filter-wrapper">
  <div class="d-flex">
    <h3 class="users-length">
      {{ dataSource?.data?.length ?? 0 }} {{ titleOverride ?? 'criteria.criteria' | translate }}
    </h3>
    <ng-container *ngIf="headerAddButton">
      <button
        mat-menu-item
        (click)="onAddCriteria()"
        matTooltip="{{ 'addCriteria.button.addCriteria' | translate }}"
        class="add-button"
      >
        <mat-icon>add_circle_outline</mat-icon>
      </button>
    </ng-container>
  </div>
</section>
<!-- / filter-wrapper -->

<table
  mat-table
  [dataSource]="dataSource"
  [class.table-portrait-override]="displayService.isPortrait"
  [class.td-portrait-override]="displayService.isPortrait"
>
  <ng-container matColumnDef="items">
    <th mat-header-cell *matHeaderCellDef>
      <ng-container *ngIf="!hideHeader">
        {{ 'criteria.content' | translate }}
      </ng-container>
    </th>
    <td mat-cell *matCellDef="let row" (click)="onEditCriteria(row.uid)">
      <span *ngFor="let item of row.items" [class]="'criteria-item-' + item.type">{{ item.value }} </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let row" class="text-end">
      <ng-container *ngIf="!hideActions">
        <button mat-icon-button>
          <mat-icon svgIcon="iconPencilOutline" (click)="onEditCriteria(row.uid)"> </mat-icon>
        </button>
        <button mat-icon-button [disabled]="removing">
          <app-trash-icon (onDelete)="onRemove(row.uid)" [track]="['Users', 'criteria_list_criteria']"></app-trash-icon>
        </button>
      </ng-container>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  <!-- Row shown when there is no matching data. -->
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="2">
      {{ 'filters.noData' | translate }}
    </td>
  </tr>
</table>

<mat-paginator
  *ngIf="!isLoading && pagination"
  (page)="handlePageEvent($event)"
  [length]="length"
  [pageSize]="pageSize"
  [showFirstLastButtons]="showFirstLastButtons"
  [pageSizeOptions]="pageSizeOptions"
  [pageIndex]="pageIndex"
  [class.portrait-paginator]="displayService.isPortrait"
>
</mat-paginator>
